export enum SpendETLStatus {
  Success = 0,
  Error = 1,
  Running = 2,
  Unknown = 3
}
